module.exports = __webpack_public_path__ + "img/zach_sieler.ed33be70.png";